module.exports = __webpack_public_path__ + "static/media/popup_2.9db2b1b8.png";